<template>
    <div>
        <section class="inner_banner charecter_page">
        </section>

        <section class="charecter">
            <div class="container-fluid">
                <h2>Characters </h2>
                <div id="demo" class="carousel slide vert" data-ride="carousel" data-interval="3000">

                    <div class="row no-gutters">
                        <div class="col-md-4">
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <div class="button_read">
                                        <img src="../assets/images/cb1.png" alt="">
                                        <div class="hover_show">
                                            <h4>Sho Yukara</h4>
                                            <router-link to="characters-single" class="btn_yellow">Read More</router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="button_read">
                                        <img src="../assets/images/cb2.png" alt="">
                                        <div class="hover_show">
                                            <h4>Subject 172</h4>
                                            <router-link to="characters-single" class="btn_yellow">Read More</router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="button_read">
                                        <img src="../assets/images/cb3.png" alt="">
                                        <div class="hover_show">
                                            <h4>Chuck</h4>
                                            <router-link to="characters-single" class="btn_yellow">Read More</router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="button_read">
                                        <img src="../assets/images/cb4.png" alt="">
                                        <div class="hover_show">
                                            <h4>Spikerock</h4>
                                            <router-link to="characters-single" class="btn_yellow">Read More</router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="button_read">
                                        <img src="../assets/images/cb5.png" alt="">
                                        <div class="hover_show">
                                            <h4>Jun Seku</h4>
                                            <router-link to="characters-single" class="btn_yellow">Read More</router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="button_read">
                                        <img src="../assets/images/cb6.png" alt="">
                                        <div class="hover_show">
                                            <h4>Bundy</h4>
                                            <router-link to="characters-single" class="btn_yellow">Read More</router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="button_read">
                                        <img src="../assets/images/cb7.png" alt="">
                                        <div class="hover_show">
                                            <h4>Marley</h4>
                                            <router-link to="characters-single" class="btn_yellow">Read More</router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="button_read">
                                        <img src="../assets/images/cb8.png" alt="">
                                        <div class="hover_show">
                                            <h4>Javier</h4>
                                            <router-link to="characters-single" class="btn_yellow">Read More</router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="button_read">
                                        <img src="../assets/images/cb9.png" alt="">
                                        <div class="hover_show">
                                            <h4>Hosokawa</h4>
                                            <router-link to="characters-single" class="btn_yellow">Read More</router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="button_read">
                                        <img src="../assets/images/cb10.png" alt="">
                                        <div class="hover_show">
                                            <h4>Tyr</h4>
                                            <router-link to="characters-single" class="btn_yellow">Read More</router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="button_read">
                                        <img src="../assets/images/cb11.png" alt="">
                                        <div class="hover_show">
                                            <h4>Malak al Mawt</h4>
                                            <router-link to="characters-single" class="btn_yellow">Read More</router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="button_read">
                                        <img src="../assets/images/cb12.png" alt="">
                                        <div class="hover_show">
                                            <h4>Hanatar</h4>
                                            <router-link to="characters-single" class="btn_yellow">Read More</router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="button_read">
                                        <img src="../assets/images/cb13.png" alt="">
                                        <div class="hover_show">
                                            <h4>Omen</h4>
                                            <router-link to="characters-single" class="btn_yellow">Read More</router-link>
                                        </div>
                                    </div>
                                </div>
                            </div><!--inner-->
                        </div><!-- col-sm-6  -->

                        <div class="col-md-8">
                            <div class="carousel-indicators">
                                <div data-target="#demo" data-slide-to="0" class="item active">
                                    <img src="../assets/images/c1.png" alt=""></div>
                                <div data-target="#demo" data-slide-to="1" class="item">
                                    <img src="../assets/images/c2.png" alt="">
                                </div>
                                <div data-target="#demo" data-slide-to="2" class="item">
                                    <img src="../assets/images/c3.png" alt="">
                                </div>
                                <div data-target="#demo" data-slide-to="3" class="item">
                                    <img src="../assets/images/c4.png" alt="">
                                </div>
                                <div data-target="#demo" data-slide-to="4" class="item">
                                    <img src="../assets/images/c5.png" alt="">
                                </div>
                                <div data-target="#demo" data-slide-to="5" class="item">
                                    <img src="../assets/images/c6.png" alt="">
                                </div>
                                <div data-target="#demo" data-slide-to="6" class="item">
                                    <img src="../assets/images/c7.png" alt="">
                                </div>
                                <div data-target="#demo" data-slide-to="7" class="item">
                                    <img src="../assets/images/c8.png" alt="">
                                </div>
                                <div data-target="#demo" data-slide-to="8" class="item">
                                    <img src="../assets/images/c9.png" alt="">
                                </div>
                                <div data-target="#demo" data-slide-to="9" class="item">
                                    <img src="../assets/images/c10.png" alt=""></div>
                                <div data-target="#demo" data-slide-to="10" class="item">
                                    <img src="../assets/images/c11.png" alt=""></div>
                                <div data-target="#demo" data-slide-to="11" class="item">
                                    <img src="../assets/images/c12.png" alt=""></div>
                                <div data-target="#demo" data-slide-to="12" class="item">
                                    <img src="../assets/images/c13.png" alt=""></div>
                            </div>
                        </div><!-- col-sm-4 Indicators -->
                    </div><!--row-->
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { getCharacters } from '@/api'

export default {
    name: "Characters",
    data () {
        return {
            characters: []
        }
    },
    methods: {
        fetchCharacters () {
            this.characters = getCharacters()
        }
    },
    created () {
        this.fetchCharacters()
    }
}
</script>

<style scoped>

</style>
